module.exports = __webpack_public_path__ + "static/with-time.16622a29.jpg";